import React from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import Table from "rc-table";
import { BaseComponent } from "../../../components/BaseComponent";
import { ProductTaskActionsContainer } from "./ProductTaskActionsContainer";
import {addProductTask, getAllProductTasks, getProductTasks} from "../actions";
import {
  REQUEST_ADD_PRODUCT_TASK,
  REQUEST_DELETE_PRODUCT_TASK,
  REQUEST_GET_ALL_PRODUCT_TASKS,
  REQUEST_GET_PRODUCT_TASKS
} from "../constants";
import { selectWorks } from "../../Api/selectors";
import { selectAllProductTasks, selectProductTasks } from "../selectors";
import { Modal, ModalControls } from "../../../components/Modal";
import { FormField } from "../../../components/FormFields";
import { Input } from "../../../components/Form";
import { Button } from "../../../components/Buttons";
import { HBox } from "../../../components/Box";
import Dropdown from "../../../components/Dropdown/ReactDropdown";

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;


const STATE = {
  selectedTask: null,
};

class ProductTasksSectionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.getAllProductTasks();
    this.props.geProductTasks();

  }

  get tasks() {
    return this.props.productTasks;
  }

  getData = t => ({
    name: t.name,
    label: t.label,
    actions: t,
    tasks: this.tasks,
    product_id: this.props.product_id,
  });

  getColumns = () => {
    const columns = [
      {title: 'Taak label', dataIndex: 'label', key: 'label', align: 'left'},
      {title: 'Taak naam', dataIndex: 'name', key: 'name', align: 'left'},
    ];
    const actionsColumn = {
      key: 'actions',
      dataIndex: 'actions',
      render(value, row, index) {
        return (
          <ProductTaskActionsContainer
            task={value}
            tasks={row.tasks}
            product_id={row.product_id}
          />
        );
      },
    };

    if (!this.props.disabled) columns.push(actionsColumn);

    return columns;
  };

  get availableTasksOptions() {
    return (this.props.allTasks ?? []).map(t => ({ label: t.label, value: t.name }));
  }

  renderEditModal() {
    if (!this.state.renderEdit) return '';

    return (
      <Modal onClose={this.setStateFn({ renderEdit: false })} title={this.lbl(`workflows.details.tasks.editModalTitle`)}>
        <FormField>
          <Input
            name="newTaskName"
            value={this.state.newTaskName ?? ''}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
        <ModalControls>
          <Button
            onClick={() => {
              this.editTask();
              this.setState({ renderEdit: false, oldTaskName: null });
            }}
            disabled={this.confirmEditBtnDisabled}
            primary
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.setStateFn({ renderEdit: false })}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  onClickAddNewTask() {
    this.props.addNewProductTask(this.state.selectedTask);
  }


  onChangeSelectedTask(evt) {
    console.log('!!! evt !!!', evt);
    this.setState({ selectedTask: evt.value });
  }

  render() {
    const columns = this.getColumns();
    const data = this.tasks?.map(t => this.getData(t));
    return (
      <>
        <HBox left className="field-block">
          <FormField label={this.lbl('workflows.details.tasksSectionTitle')}>
            <HBox>
              <Dropdown
                options={this.availableTasksOptions}
                value={this.state.selectedTask}
                onChange={this.onChangeSelectedTask.bind(this)}
              />
              <Button small onClick={this.onClickAddNewTask.bind(this)}>
                {this.lbl('workflows.details.addNewProductBtn')}
              </Button>
            </HBox>
          </FormField>
        </HBox>
        <Container>
          <CustomTable
            columns={columns}
            data={data}
            // scroll={{x: window.innerWidth < 975 ? 975 : false}}
            emptyText='Geen taken toegevoegd'
            onRow={(record, index) => ({
              onClick: () => this.onClickEdit(record.name),
            })}
          />
          {this.renderEditModal()}
        </Container>
      </>
    );
  }

}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_GET_ALL_PRODUCT_TASKS,
      REQUEST_GET_PRODUCT_TASKS,
      REQUEST_ADD_PRODUCT_TASK,
      REQUEST_DELETE_PRODUCT_TASK,
    ]),
    allTasks: selectAllProductTasks(),
    productTasks: selectProductTasks(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getAllProductTasks() {
      dispatch(getAllProductTasks());
    },
    geProductTasks() {
      dispatch(getProductTasks(ownProps.product_id));
    },
    addNewProductTask(taskName) {
      dispatch(addProductTask(ownProps.product_id, taskName));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ProductTasksSection = compose(
  withConnect,
  withRouter,
)(ProductTasksSectionComp);
